import { Transform } from 'class-transformer';
import { AmtSeasonDto } from '../allowable-assortment/amt-season.dto';
import { DeliveryAddressModel } from '../delivery-address.model';
import { OriginApp } from '../origin-app.enum';
import { sanitizeString } from '../utils';
import { OrderDocumentModel } from './order-document.model';
import { SalesOrderHoldModel } from './order-hold.model';
import { OrderReturnType } from './order-return-type.enum';
import { OrderType } from './order-type.enum';
import { PackingSlipTrackingInformationModel } from './packing-slip-tracking-information.model';
import { PreOrderDiscountsModel } from './pre-order-discounts.model';
import { SalesInvoiceHeaderModel } from './sales-invoice-header.model';
import { ShippingSettingsModel } from './shipping-settings.model';
import { TrackingObjectModel } from './tracking-object.model';

export class OrderHeaderModel {
  @Transform(({ value }) => sanitizeString(value))
  public customerPoNumber: string;
  public id: string;
  public orderNumber: string;
  public userId: string;
  public locationName: string;
  public accountId: string;
  public date: Date | string;
  public dueDate: Date | string;
  public type: OrderType;
  public itemShipped: number;
  public quantityToShip: number;
  public status: string;
  public currencyCode: string;
  public salesTaker: string;
  public transferStatus: string;
  public recordType: string;
  public caseNumber: string;
  public cancelledDate: Date | string;
  public invoiceAccountId: string;
  public salesAgent: string;

  public total?: number;
  public subTotal?: number;
  public deliveryTerms?: string;
  public paymentTerms?: string;
  public orderConfirmationDate?: Date | string;
  public deliveryAddress?: DeliveryAddressModel;
  public shippingSettings?: ShippingSettingsModel;
  public orderConfirmation?: OrderDocumentModel;
  public packingSlips?: OrderDocumentModel[];
  public salesInvoiceHeaders?: SalesInvoiceHeaderModel[];
  public trackingNumbers?: TrackingObjectModel[];
  public preOrderDiscounts?: PreOrderDiscountsModel;
  public contactId?: string;
  public documentStatus: string;
  public packingSlipTrackingInfo?: PackingSlipTrackingInformationModel[];
  public returnType?: OrderReturnType;
  public returnReasonCode?: string;
  public salesOrderHolds?: SalesOrderHoldModel[];
  public origin?: OriginApp;
  public quantitiesPerStatus?: { _id: string; quantity: number };
  public confirmId?: string;
  public confirmationNumber?: string;
  public duplicatable?: boolean;
  public isEditedByDealer?: boolean;
  public isCreatedViaExcelUpload?: boolean;
  public createdAt: Date | string;

  /**
   * When creating multiple pre-orders, we should be able to group them using a groupId
   * @example '9a48e37a-e9f1-43e8-a1d4-a933ef1bbb8e'
   */
  public groupId?: string;

  /**
   * Order number corresponding to the order from which this order was cloned/created.
   * Should be a sales order number or a draft order number
   * @example SO01B0041950U
   */
  public sourceOrderNumber?: string;

  /**
   * Seasons array to which a draft belongs too. We can have complete amtSeasons data.
   * For pre-orders, the array should normally contain just one value, given
   * atm there is never 2 pre-order seasons open at the same time.
   * @example ['FW22', 'SS23'] || [{name: 'FW22', startDate: '2022-03-01', endDate: '2022-09-01', seasonSellInPeriods: []}]
   */
  public seasons?: string[] | AmtSeasonDto[];

  /**
   * @deprecated
   */
  public ConfirmId?: string;

  /**
   * @deprecated
   */
  public externalId?: string;

  /**
   * @deprecated
   */
  public locationId?: string;

  /**
   * ToDo: remove this field as soon as SF changes it to be id on /backstage/orders/lines?orderId=x endpoint response
   * @deprecated
   */
  public orderId?: string;
}
